import type { EventData } from '../types/events.types';

export const SAMPLE_PLAN_EVENTS: EventData[] = [
  {
    id: 'plan_evt_1',
    eventType: 'plan.created',
    description: 'Subscription plan "Small License" created with monthly recurring billing',
    timestamp: '10/1/25, 10:00:00 AM',
    requestId: 'req_plan_create_xyz123',
    status: 'succeeded'
  },
  {
    id: 'plan_evt_2',
    eventType: 'plan.activated',
    description: 'Plan activated and made available for new subscriptions',
    timestamp: '10/1/25, 10:15:00 AM',
    requestId: 'req_plan_activate_abc456',
    status: 'succeeded'
  },
  {
    id: 'plan_evt_3',
    eventType: 'subscription.started',
    description: 'First subscription created under this plan for Customer ABC Corp',
    timestamp: '10/2/25, 2:30:00 PM',
    requestId: 'req_sub_start_def789',
    status: 'succeeded'
  },
  {
    id: 'plan_evt_4',
    eventType: 'plan.pricing_updated',
    description: 'Pricing phase updated - Monthly fee increased to $120.00',
    timestamp: '10/15/25, 9:00:00 AM',
    requestId: 'req_plan_price_ghi012',
    status: 'succeeded'
  },
  {
    id: 'plan_evt_5',
    eventType: 'subscription.renewal',
    description: '15 subscriptions successfully renewed for current billing period',
    timestamp: '11/1/25, 12:00:00 AM',
    requestId: 'req_sub_renew_jkl345',
    status: 'succeeded'
  }
];
